module.exports = __webpack_public_path__ + "img/ES0232.8f11c39d.png";